/* Amit Pasha — accessibility toolbar. Choices live on <html> as a11y-* classes and are remembered in localStorage
   (the same keys are applied in <head> before paint, see layout/theme.liquid, so pages don't flash). */
(function () {
  'use strict';
  var root = document.querySelector('[data-a11y]'); if (!root) return;
  var html = document.documentElement, KEY = 'ap_a11y';
  var btn = root.querySelector('[data-a11y-open]'), panel = root.querySelector('#A11yPanel'), guide = root.querySelector('[data-a11y-guide]');
  var state = {};
  try { state = JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { state = {}; }

  function save() { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }
  function apply() {
    root.querySelectorAll('[data-a11y-toggle]').forEach(function (b) {
      var k = b.getAttribute('data-a11y-toggle'), on = !!state[k];
      html.classList.toggle('a11y-' + k, on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var z = state.size || 0; html.style.setProperty('--a11y-zoom', (1 + z * 0.1).toFixed(2)); html.classList.toggle('a11y-zoom', z !== 0);
    root.querySelector('[data-a11y-sizeval]').textContent = Math.round((1 + z * 0.1) * 100) + '%';
    document.querySelectorAll('video').forEach(function (v) { if (state.still) { v.dataset.a11yWasPlaying = v.paused ? '' : '1'; v.pause(); } else if (v.dataset.a11yWasPlaying) { v.play().catch(function () {}); v.dataset.a11yWasPlaying = ''; } });
    root.classList.toggle('is-active', Object.keys(state).some(function (k) { return state[k]; }));
  }

  function open() { panel.hidden = false; btn.setAttribute('aria-expanded', 'true'); var f = panel.querySelector('button'); if (f) f.focus(); }
  function close(back) { panel.hidden = true; btn.setAttribute('aria-expanded', 'false'); if (back) btn.focus(); }

  btn.addEventListener('click', function () { panel.hidden ? open() : close(true); });
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-a11y-close]')) { close(true); return; }
    var t = e.target.closest('[data-a11y-toggle]');
    if (t) {
      var k = t.getAttribute('data-a11y-toggle'); state[k] = !state[k];
      if (k === 'contrast' && state[k]) state.dark = false;
      if (k === 'dark' && state[k]) state.contrast = false;
      save(); apply(); return;
    }
    var s = e.target.closest('[data-a11y-size]');
    if (s) { state.size = Math.max(-1, Math.min(5, (state.size || 0) + parseInt(s.getAttribute('data-a11y-size'), 10))); if (!state.size) delete state.size; save(); apply(); return; }
    if (e.target.closest('[data-a11y-reset]')) { state = {}; save(); apply(); }
  });
  // Escape closes; Tab stays inside the open panel
  panel.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { e.preventDefault(); close(true); return; }
    if (e.key !== 'Tab') return;
    var f = panel.querySelectorAll('button, a[href]'), first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  document.addEventListener('click', function (e) { if (!panel.hidden && !root.contains(e.target)) close(false); });
  // reading guide follows the pointer
  document.addEventListener('mousemove', function (e) { if (state.guide) guide.style.transform = 'translateY(' + (e.clientY - 18) + 'px)'; }, { passive: true });

  apply();
})();
